import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "information",
  "use": "information-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"information\"><path d=\"M9 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2m.75 1H8.5A1.5 1.5 0 0 0 7 9.5h1.25v1.758A1.284 1.284 0 0 0 7 12.538v.212h2.753c.688 0 1.247-.558 1.247-1.247v-.253H9.75zM9 1.714C4.983 1.714 1.714 4.982 1.714 9S4.984 16.286 9 16.286c4.017 0 7.286-3.268 7.286-7.286S13.017 1.714 9 1.714M9 15A6 6 0 1 1 9 3a6 6 0 1 1 0 12\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol